import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Blank from '../../../hoc/Blank/Blank';
import ContactData from '../../../components/Order/ContactData/ContactData';
import MulchTypes from '../../../components/Order/MulchTypes/MulchTypes';
import OrderTotal from '../../../components/Order/OrderTotal/OrderTotal';
import DeliveryType from '../../../components/Order/DeliveryType/DeliveryType';
import PaymentType from '../../../components/Order/PaymentType/PaymentType';
import OrderButtons from '../../../components/Order/OrderButtons/OrderButtons';
import Modal from '../../../components/UI/Modal/Modal';
import ScoutSelector from '../../../components/Order/ScoutSelector/ScoutSelector';
import AddOrderErrorModal from '../../../components/ErrorModals/AddOrderErrorModal/AddOrderErrorModal';
import Notes from '../../../components/Order/Notes/Notes';
import * as actions from '../../../store/actions/index';

class AdminOrder extends Component {
    state = {
        orderId: 0,
        addOrder: null,
        orderMode: 'add',
        orderValid: true,
        cancel: false,
        reload: false,
        closeModal: false,
        filteredUserId: 0,
        loaded : false
    }

    componentDidMount () {        
        console.log(this.props);
        if (this.props.filteredUserId && !isNaN(this.props.filteredUserId)) {
            this.setState({filteredUserId:this.props.filteredUserId});
        }
        if (! this.props.orderId && this.props.orderId == '0') {
            this.props.onInitOrder();
        }
        else if (this.props.orderId && this.props.orderId != '0') {
          this.setState({orderId:this.props.orderId,orderMode:'update'});
          let order = null;
          for (let key in this.props.orders) {
            if (this.props.orders[key].orderId == this.props.orderId) {
                order = this.props.orders[key]
                this.setState({addOrder:order});
                this.props.onSetEditOrder(this.props.orderId,order);
              break;
            }
          }
          if (!order) {
            this.props.onInitOrder();
            this.setState({orderId:this.props.orderId,orderMode:'add'});
            for (let ckey in this.props.callorders) {
                if (this.props.callorders[ckey].orderId == this.props.orderId) {
                    order = this.props.callorders[ckey];
                    this.setState({addOrder:order});
                    this.props.onSetAddCallListOrder(this.props.orderId,order);
                  break;
                }
              }
            if (!order) {
                for (let ckey in this.props.searchOrders) {
                    if (this.props.searchOrders[ckey].orderId == this.props.orderId) {
                        order = this.props.searchOrders[ckey];
                        this.setState({addOrder:order});
                        this.props.onSetAddCallListOrder(this.props.orderId,order);
                      break;
                    }
                  } 
            }
          }
          if (!order) {
            this.setState({orderId:this.props.orderId,orderMode:'add'});
            for (let ckey in this.props.searchOrders) {
                if (this.props.searchOrders[ckey].orderId == this.props.orderId) {
                    order = this.props.searchOrders[ckey];
                    this.props.onSetAddCallListOrder(this.props.orderId,order);
                  break;
                }
              }
          }
          console.log(order);
          let totalBags1 = parseInt(order.blackBags,10) + parseInt(order.redBags,10) + parseInt(order.hardwoodBags,10) + parseInt(order.cedarBags,10);
          let total = 4.5 * totalBags1;
          this.props.onUpdateOrder('totalBags',totalBags1);
          this.props.onUpdateOrder('total',total);

        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.submitted) {
            this.props.onInitOrder();
            if (this.props.mode == 'admin') {
                this.props.history.push('/adminOrders?' + this.state.filteredUserId + '&updated');
            }
            else {
              this.props.history.push('/showOrders?updated');
            }
        }
       
      if (this.props.order.isInArea && prevProps.order.isInArea == null) {
        if (this.props.order.isInArea) {
            this.props.onUpdateOrder('deliveryType','delivery');
            this.props.onUpdateOrder('deliveryType_valid',true);
            this.props.onUpdateOrder('deliveryType_touched',true);
        }
        else {
            this.props.onUpdateOrder('deliveryType','pickup');
            this.props.onUpdateOrder('deliveryType_valid',true);
            this.props.onUpdateOrder('deliveryType_touched',true);
        }
      }
    }

    validatePage ()  {
      
        let valid = true;
        valid = valid && this.validateIdentifier('name');
        valid = this.validateIdentifier('address') && valid;
        valid = this.validateIdentifier('city') && valid;
        valid = this.validateIdentifier('zip') && valid;
        valid = this.validateIdentifier('phone') && valid;
        valid = this.validateIdentifier('email') && valid;
        valid = this.validateIdentifier('address') && valid;
        valid = this.validateIdentifier('hardwoodBags') && valid;
        valid = this.validateIdentifier('cedarBags') && valid;
        valid = this.validateIdentifier('blackBags') && valid;
        valid = this.validateIdentifier('redBags') && valid;
        valid = this.validateIdentifier('cashAmount') && valid;
        valid = this.validateIdentifier('checkAmount') && valid;
        valid = this.validateIdentifier('checkNumber') && valid;
    
        if (this.props.order.totalBags == 0)
        {
            this.props.onUpdateOrder('hardwoodBags_touched',true);
            this.props.onUpdateOrder('cedarBags_touched',true);
            this.props.onUpdateOrder('blackBags_touched',true);
            this.props.onUpdateOrder('redBags_touched',true);
            this.props.onUpdateOrder('hardwoodBags_valid',false);
            this.props.onUpdateOrder('cedarBags_valid',false);
            this.props.onUpdateOrder('blackBags_valid',false);
            this.props.onUpdateOrder('redBags_valid',false);
            valid = false;
        }
        
        return valid;
    }


    validateIdentifier (identifier) 
    {
        if (this.props.order[identifier + '_valid'] == false)
        {
            this.props.onUpdateOrder(identifier + '_touched',true);
            return false;
        }
        return true;
    }
    PaymentChanged = (id,value) => {
        console.log("IN PAYMENT CHANGED");
        let cashAmount = parseFloat(this.props.order.cashAmount);
        let checkAmount = parseFloat(this.props.order.checkAmount);
        let checkNumber = this.props.order.checkNumber;
        if (id==="cashAmount") {
            cashAmount = value;
        }
        if (id==="checkAmount") {
            checkAmount = value;
        }
        if (id==="checkhNumber") {
           checkNumber = value;
        }
        this.props.onUpdateOrder(id,value);
    }

    DataChanged = (id,value) => {
        this.props.onUpdateOrder(id,value);
        if (id !== "blackBags" && id !== "hardwoodBags" && id !== "cedarBags" && id !== "redBags") {
            return;
        }
        let totalBags = parseInt(this.props.order.blackBags,10) + parseInt(this.props.order.redBags,10) + parseInt(this.props.order.hardwoodBags,10) + parseInt(this.props.order.cedarBags,10);
        let initialBags = totalBags;
        let hardwoodBags = parseInt(this.props.order.hardwoodBags,10);
        let blackBags = parseInt(this.props.order.blackBags,10);
        let cedarBags = parseInt(this.props.order.cedarBags,10);
        let redBags = parseInt(this.props.order.redBags,10);
        if (id == "blackBags") {
            blackBags = value ;
        }
        if (id == "redBags") {
            redBags = value ;
        }
        if (id == "cedarBags") {
            cedarBags = value;
        }
        if (id == "hardwoodBags") {
            hardwoodBags = value;            
        }
        totalBags = parseInt(hardwoodBags,10) + parseInt(blackBags,10) + parseInt(cedarBags,10) + parseInt(redBags,10);        
             
        if (totalBags != initialBags)
        {
            let total = 4.5 * totalBags;
            this.props.onUpdateOrder('totalBags',totalBags);
            this.props.onUpdateOrder('total',total);
        }

    }

    modalCancelHandler = () => {
        this.setState({orderValid: true});
    }

    cancelPageHandler = () => {
        this.props.onInitOrder();
        if (this.props.mode == 'admin') {
            this.props.history.push('/adminOrders?' + this.state.filteredUserId);
        }
        else {
            this.props.history.push('/showOrders');
        }
    }

    submitOrder = () => {
        if (!this.validatePage())
        {
            this.setState({orderValid:false});
        }
        else
        {
            this.setState({orderValid:true});
                        

            let address = this.props.order.address + ',' + this.props.order.city + ' ' + this.props.order.zipCode;
            this.props.onSubmitOrder();
        }
    }    

    AddressChanged = (address,city,zip,geoAddress) => {
        if (geoAddress == this.props.order.geoAddress)
        {            
            return;
        }
        this.props.onUpdateGeoCode(address,city,zip,geoAddress);        
   };


    render () {
        let modal = null;
        
        if (!this.state.orderValid)
        {
            modal = <AddOrderErrorModal modalClosed={this.modalCancelHandler}/>;
        }
console.log(this.props.order)
        let scoutSel = null;
        if (this.props.order.userId != 0) {
        if (this.props.mode == 'admin') {
           // let uid = this.props.order.userId
           // if (uid == 0) {
           //     uid = order.userId
           // }
            scoutSel = <ScoutSelector onDataChanged={this.DataChanged} order={this.state.addOrder} scoutUserId={this.props.order.userId}></ScoutSelector>;
        }
    }
        return (
            <Blank>
                {scoutSel}
                <Modal show={modal != null && !this.state.orderValid} modalClosed={this.cancelPageHandler}>
                    {modal}
                </Modal>
                <ContactData onAddressChanged={this.AddressChanged} 
                    onDataChanged={this.DataChanged}/>
                <MulchTypes
                    onDataChanged={this.DataChanged}/>
                <OrderTotal total={this.props.order.total} totalBags={this.props.order.totalBags}/>
                <DeliveryType  onDataChanged={this.DataChanged}/>
                <Notes  onDataChanged={this.DataChanged}/>
                <PaymentType onDataChanged={this.DataChanged}/>
                <OrderButtons  onOrderSubmitted={this.submitOrder} onOrderCancelled={this.cancelPageHandler}/>
            </Blank>
        );
    }
}


const mapStateToProps = state => {
    return {
      orders: state.orders.orders,
      callorders: state.orders.callList,
      order: state.orders.order,        
      isAuthenticated: state.orders.token !== null,
      submitted: state.orders.submitted,
      userType: state.orders.userType,
      searchOrders: state.orders.searchResults
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onInitOrder: () => dispatch(actions.initOrder()),
        onSetEditOrder:(id,orderData) => dispatch(actions.setEditOrder(id,orderData)),
        onSetAddCallListOrder:(id,orderData) => dispatch(actions.setAddCallListOrder(id,orderData)),
        onUpdateGeoCode:(address,city,zip,geoAddress) => dispatch(actions.updateGeoCode(address,city,zip,geoAddress)),
        onUpdateOrder: (id,value) => dispatch(actions.updateOrder(id,value)),
        onSubmitOrder:() => dispatch(actions.submitOrder())
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AdminOrder);


// WEBPACK FOOTER //
// ./src/containers/Orders/AdminOrder/AdminOrder.js